<template>
  <div class="page-container">
    <div class="page-header">
      <div class="header-top">
        <div class="top-title" @click="searchFlag = false">
          数字员工人才广场
        </div>
        <div>
          <a-input-search
            v-model:value="searchVal"
            placeholder="搜索"
            style="width: 300px; border-radius: 8px"
            allow-clear
            @search="onSearch"
            @change="searchChange"
          />
        </div>
      </div>
      <div class="header-bottom">
        <div
          :class="{
            'bottom-item': true,
            'bottom-item-active': item.id === activeKey,
          }"
          @click="scrollToSection(item)"
          v-for="item in state.marketLists"
          :key="item.id"
        >
          {{ item.name }}
        </div>
      </div>
    </div>
    <template v-if="searchFlag">
      <div class="page-content">
        <MarketCards
          :queryType="tagName"
          :searchStr="searchStr"
          :load-more="true"
        />
      </div>
    </template>
    <template v-else>
      <!-- 首页 -->
      <div class="page-content" v-for="idx in state.marketLists" :key="idx.id">
        <div
          class="content-title"
          @click="changeTags(idx.id, idx.name)"
          :id="idx.sectionId"
          :style="{ 'scroll-margin-top': '100px' }"
        >
          {{ idx.name }} <i><RightOutlined /></i>
        </div>
        <div class="content-cards">
          <div
            class="cards-item"
            v-for="item in state.allData?.dataTable[idx.name]"
            :key="item"
            @click="handleClick(item)"
          >
            <div class="item-left">
              <img :src="item.photo" alt="" />
            </div>
            <div class="item-right">
              <div class="__title">{{ item.ProcessName }}</div>
              <div class="__content">
                {{ item.processDesc }}
              </div>
              <div class="__bottom">
                <div>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    width="10"
                    height="10.000006675720215"
                    viewBox="0 0 10 10.000006675720215"
                    fill="none"
                  >
                    <path
                      d="M3.5 5C2.1 5 1 3.9 1 2.50001C1 1.1 2.1 0 3.5 0C4.90001 0 6 1.1 6 2.50001C6 3.9 4.90001 5 3.5 5ZM3.5 1C2.65001 1 2 1.65 2 2.50001C2 3.35 2.65001 4.00001 3.5 4.00001C4.35 4.00001 5 3.35 5 2.50001C5 1.65 4.35 1 3.5 1ZM6.5 10C6.2 10 6 9.8 6 9.5L6 8.50001C6 7.65 5.35001 7.00001 4.5 7.00001L2.50001 7.00001C1.65 7.00001 1 7.65 1 8.50001L1 9.5C1 9.8 0.8 10 0.5 10C0.2 10 0 9.8 0 9.5L0 8.50001C0 7.1 1.1 6 2.50001 6L4.5 6C5.9 6 7.00001 7.1 7.00001 8.50001L7.00001 9.5C7.00001 9.8 6.8 10 6.5 10ZM7.00001 4.95C6.8 4.95 6.55001 4.8 6.5 4.55C6.45 4.30001 6.6 4.00001 6.85001 3.95C7.4 3.8 7.8 3.40001 7.95 2.85C8.15 2.05001 7.65 1.25 6.85001 1C6.6 1 6.45 0.700003 6.5 0.449995C6.55001 0.199999 6.85001 -1.16229e-06 7.1 0.0999996C8.45 0.449995 9.25001 1.8 8.9 3.15C8.65001 4.05 8 4.75001 7.1 4.95L7.00001 4.95ZM9.5 10C9.2 10 9 9.8 9 9.5L9 8.50001C9 7.8 8.55 7.25 7.85 7.05C7.60001 7.00001 7.4 6.70001 7.5 6.45C7.60001 6.2 7.85 6 8.1 6.10001C9.2 6.40001 9.95 7.35 10 8.50001L10 9.5C10 9.8 9.8 10 9.5 10Z"
                      fill="#A6A6A6"
                    ></path>
                  </svg>
                  {{ item.usePeople }}
                </div>
                <div>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    width="11"
                    height="10.500020027160645"
                    viewBox="0 0 11 10.500020027160645"
                    fill="none"
                  >
                    <path
                      d="M5.5 0C8.5375 0 11 2.3505 11 5.25C11 8.1495 8.5375 10.5 5.5 10.5C5.44077 10.5002 5.38155 10.4994 5.32234 10.4977C5.26314 10.496 5.20398 10.4933 5.14485 10.4898C5.08574 10.4862 5.02669 10.4818 4.96769 10.4764C4.90871 10.471 4.84983 10.4646 4.79105 10.4574C4.73226 10.4501 4.6736 10.442 4.61508 10.4329C4.55655 10.4238 4.49817 10.4138 4.43995 10.4029C4.38173 10.392 4.3237 10.3802 4.26586 10.3675C4.20802 10.3547 4.15038 10.3411 4.09296 10.3266C4.03554 10.3121 3.97836 10.2966 3.92142 10.2803C3.86449 10.264 3.80782 10.2468 3.75142 10.2287C3.69503 10.2106 3.63892 10.1917 3.58311 10.1718C3.52731 10.152 3.47183 10.1312 3.41666 10.1097C3.36151 10.0881 3.3067 10.0656 3.25225 10.0423C3.1978 10.0191 3.14372 9.99491 3.09001 9.96992C3.03632 9.94492 2.98303 9.9191 2.93013 9.89244C2.87725 9.86578 2.82478 9.8383 2.77275 9.81L1.40875 10.4035C1.40346 10.4058 1.39813 10.408 1.39276 10.4101C1.38739 10.4122 1.382 10.4143 1.37657 10.4162C1.37113 10.4181 1.36567 10.42 1.36016 10.4217C1.35466 10.4234 1.34913 10.4251 1.34358 10.4266C1.33802 10.4282 1.33245 10.4296 1.32684 10.431C1.32124 10.4323 1.31561 10.4336 1.30996 10.4347C1.30431 10.4359 1.29865 10.437 1.29295 10.4379C1.28727 10.4389 1.28156 10.4398 1.27584 10.4405C1.27014 10.4413 1.26441 10.4419 1.25866 10.4425C1.25293 10.4431 1.24719 10.4436 1.24143 10.4439C1.23567 10.4443 1.22991 10.4446 1.22414 10.4447C1.21839 10.4449 1.21262 10.445 1.20684 10.4449C1.20108 10.4449 1.19532 10.4448 1.18956 10.4445C1.18379 10.4443 1.17804 10.444 1.17229 10.4436C1.16654 10.4431 1.1608 10.4426 1.15506 10.442C1.14933 10.4414 1.14361 10.4406 1.13791 10.4398C1.1322 10.439 1.1265 10.4381 1.12082 10.437C1.11515 10.436 1.10949 10.4349 1.10385 10.4337C1.09822 10.4325 1.0926 10.4311 1.08701 10.4297C1.08142 10.4283 1.07585 10.4268 1.07031 10.4252C1.06477 10.4236 1.05926 10.4219 1.05379 10.4201C1.0483 10.4183 1.04286 10.4164 1.03744 10.4144C1.03203 10.4125 1.02665 10.4104 1.0213 10.4082C1.01596 10.406 1.01066 10.4038 1.00539 10.4014C1.00012 10.3991 0.994902 10.3966 0.989722 10.3941C0.984542 10.3916 0.97941 10.3889 0.974324 10.3862C0.96923 10.3835 0.964187 10.3807 0.959195 10.3778C0.954203 10.3749 0.949261 10.372 0.944371 10.3689C0.93948 10.3659 0.934644 10.3627 0.929863 10.3595C0.925082 10.3563 0.920359 10.353 0.915695 10.3496C0.911023 10.3462 0.906414 10.3427 0.901867 10.3392C0.89732 10.3356 0.892835 10.332 0.888414 10.3283C0.883992 10.3246 0.879636 10.3208 0.875347 10.317C0.871058 10.3131 0.866836 10.3092 0.862679 10.3052C0.858523 10.3012 0.854437 10.2971 0.850421 10.293C0.846414 10.2888 0.842473 10.2846 0.838597 10.2803C0.83473 10.2761 0.830937 10.2717 0.827218 10.2673C0.8235 10.2629 0.819859 10.2584 0.816296 10.2539C0.812734 10.2494 0.80925 10.2448 0.805843 10.2401C0.802445 10.2355 0.799125 10.2307 0.795882 10.226C0.79264 10.2212 0.78948 10.2164 0.786402 10.2115C0.783332 10.2066 0.780343 10.2017 0.777437 10.1967C0.774531 10.1917 0.771715 10.1867 0.768988 10.1816C0.766261 10.1765 0.763621 10.1714 0.761066 10.1662C0.758511 10.1611 0.75605 10.1559 0.753683 10.1506C0.751308 10.1453 0.749027 10.14 0.746839 10.1347C0.744651 10.1294 0.742554 10.124 0.740546 10.1186C0.738546 10.1132 0.736641 10.1077 0.734828 10.1023C0.733008 10.0968 0.731289 10.0913 0.729671 10.0858C0.728046 10.0802 0.726516 10.0747 0.725078 10.0691C0.723648 10.0635 0.722316 10.0579 0.721082 10.0523C0.719839 10.0466 0.718699 10.041 0.71766 10.0353C0.71662 10.0296 0.715676 10.0239 0.714824 10.0182C0.71398 10.0125 0.713234 10.0068 0.712585 10.0011C0.711937 9.99535 0.71139 9.9896 0.710945 9.98385C0.7105 9.9781 0.710151 9.97234 0.709902 9.96659C0.709652 9.96082 0.7095 9.95506 0.709445 9.94929C0.709398 9.94352 0.709448 9.93776 0.709597 9.93199C0.709746 9.92623 0.709996 9.92046 0.710347 9.91471C0.710691 9.90895 0.711141 9.9032 0.711695 9.89746C0.712242 9.89173 0.712887 9.886 0.713628 9.88028C0.714378 9.87456 0.715222 9.86885 0.71616 9.86316C0.717105 9.85747 0.718148 9.8518 0.719289 9.84614C0.720429 9.84049 0.721668 9.83487 0.723003 9.82926L1.07175 8.36425C0.397999 7.493 0 6.41575 0 5.25C0 2.3505 2.4625 0 5.5 0ZM5.5 0.75C2.869 0.75 0.750003 2.7725 0.750003 5.25C0.750003 6.1825 1.0495 7.0715 1.60024 7.81975L1.665 7.9055L1.88425 8.189L1.56825 9.516L2.81025 8.976L3.13225 9.15201C3.846 9.54175 4.656 9.75 5.5 9.75C8.131 9.75 10.25 7.7275 10.25 5.25C10.25 2.7725 8.131 0.75 5.5 0.75ZM3.652 4.75C3.66018 4.75 3.66836 4.7502 3.67653 4.75061C3.68471 4.751 3.69287 4.7516 3.701 4.75241C3.70915 4.75321 3.71727 4.7542 3.72536 4.75541C3.73346 4.75662 3.74153 4.75801 3.74954 4.75961C3.75757 4.76121 3.76555 4.763 3.77348 4.76499C3.78143 4.76698 3.7893 4.76916 3.79713 4.77154C3.80497 4.77391 3.81274 4.77647 3.82044 4.77922C3.82815 4.78198 3.83578 4.78493 3.84334 4.78806C3.8509 4.79119 3.85837 4.7945 3.86577 4.79801C3.87318 4.80151 3.88048 4.80518 3.88769 4.80904C3.89491 4.81289 3.90204 4.81693 3.90905 4.82114C3.91607 4.82535 3.92298 4.82972 3.92978 4.83427C3.93659 4.83881 3.94328 4.84352 3.94985 4.8484C3.95643 4.85327 3.96287 4.8583 3.96919 4.86349C3.97552 4.86868 3.98171 4.87403 3.98777 4.87952C3.99384 4.88502 3.99976 4.89066 4.00555 4.89645C4.01134 4.90224 4.01699 4.90816 4.02247 4.91422C4.02797 4.92028 4.03331 4.92648 4.0385 4.93281C4.04369 4.93913 4.04872 4.94557 4.0536 4.95215C4.05847 4.95872 4.06318 4.96541 4.06773 4.97222C4.07228 4.97903 4.07666 4.98593 4.08085 4.99295C4.08507 4.99997 4.08911 5.00708 4.09296 5.0143C4.09682 5.02152 4.1005 5.02883 4.10399 5.03623C4.10749 5.04362 4.11081 5.0511 4.11394 5.05866C4.11708 5.06622 4.12002 5.07386 4.12277 5.08156C4.12553 5.08925 4.12809 5.09702 4.13046 5.10486C4.13285 5.11269 4.13503 5.12058 4.13701 5.12851C4.139 5.13645 4.1408 5.14443 4.14239 5.15245C4.14398 5.16048 4.14539 5.16853 4.14659 5.17663C4.14779 5.18473 4.14879 5.19285 4.14959 5.20099C4.15039 5.20914 4.15099 5.21729 4.15139 5.22546C4.1518 5.23364 4.152 5.24182 4.152 5.25C4.152 5.25818 4.1518 5.26636 4.15139 5.27454C4.15099 5.28271 4.15039 5.29086 4.14959 5.29901C4.14879 5.30715 4.14779 5.31526 4.14659 5.32336C4.14539 5.33146 4.14398 5.33952 4.14239 5.34755C4.1408 5.35557 4.139 5.36356 4.13701 5.37149C4.13503 5.37942 4.13285 5.38731 4.13046 5.39514C4.12809 5.40298 4.12553 5.41075 4.12277 5.41845C4.12002 5.42615 4.11708 5.43379 4.11394 5.44134C4.11081 5.4489 4.10749 5.45638 4.10399 5.46377C4.1005 5.47117 4.09682 5.47848 4.09296 5.4857C4.08911 5.49292 4.08507 5.50003 4.08085 5.50705C4.07666 5.51407 4.07228 5.52097 4.06773 5.52778C4.06318 5.53459 4.05847 5.54128 4.0536 5.54786C4.04872 5.55443 4.04369 5.56088 4.0385 5.5672C4.03331 5.57352 4.02797 5.57972 4.02247 5.58578C4.01699 5.59184 4.01134 5.59777 4.00555 5.60356C3.99976 5.60934 3.99384 5.61498 3.98777 5.62048C3.98171 5.62597 3.97552 5.63132 3.96919 5.63651C3.96287 5.6417 3.95643 5.64673 3.94984 5.6516C3.94328 5.65648 3.93659 5.66119 3.92978 5.66573C3.92298 5.67028 3.91607 5.67465 3.90905 5.67886C3.90204 5.68307 3.89491 5.68711 3.88769 5.69097C3.88048 5.69482 3.87318 5.69849 3.86577 5.70199C3.85837 5.7055 3.8509 5.70881 3.84334 5.71194C3.83578 5.71507 3.82815 5.71801 3.82044 5.72077C3.81274 5.72352 3.80497 5.72609 3.79713 5.72847C3.7893 5.73084 3.78143 5.73302 3.77348 5.73502C3.76555 5.737 3.75757 5.73879 3.74954 5.7404C3.74153 5.74199 3.73346 5.74338 3.72537 5.74459C3.71727 5.7458 3.70915 5.74679 3.701 5.74759C3.69287 5.7484 3.68471 5.749 3.67653 5.7494C3.66836 5.74981 3.66018 5.75 3.652 5.75C3.64382 5.75 3.63564 5.74981 3.62746 5.7494C3.61929 5.749 3.61113 5.7484 3.60299 5.74759C3.59486 5.74679 3.58673 5.7458 3.57864 5.74459C3.57054 5.74338 3.56248 5.74199 3.55445 5.7404C3.54643 5.73879 3.53845 5.737 3.53051 5.73502C3.52257 5.73302 3.51469 5.73084 3.50686 5.72847C3.49903 5.72609 3.49126 5.72352 3.48355 5.72077C3.47585 5.71801 3.46822 5.71507 3.46065 5.71194C3.45311 5.70881 3.44563 5.7055 3.43822 5.70199C3.43083 5.69849 3.42352 5.69482 3.4163 5.69097C3.40908 5.68711 3.40196 5.68307 3.39494 5.67886C3.38794 5.67465 3.38102 5.67028 3.37421 5.66573C3.36742 5.66119 3.36073 5.65648 3.35415 5.6516C3.34758 5.64673 3.34113 5.6417 3.3348 5.63651C3.32848 5.63132 3.32229 5.62597 3.31622 5.62048C3.31016 5.61498 3.30423 5.60934 3.29844 5.60356C3.29266 5.59777 3.28703 5.59184 3.28152 5.58578C3.27603 5.57972 3.27069 5.57352 3.26549 5.56719C3.26031 5.56088 3.25527 5.55442 3.25039 5.54784C3.24552 5.54127 3.24081 5.53459 3.23626 5.52778C3.23171 5.52097 3.22734 5.51407 3.22314 5.50705C3.21893 5.50003 3.2149 5.49292 3.21103 5.4857C3.20719 5.47848 3.20351 5.47117 3.2 5.46377C3.19651 5.45638 3.1932 5.4489 3.19005 5.44134C3.18693 5.43379 3.18398 5.42615 3.18123 5.41845C3.17848 5.41075 3.17591 5.40298 3.17353 5.39514C3.17116 5.38731 3.16897 5.37942 3.16698 5.37149C3.165 5.36356 3.16321 5.35557 3.1616 5.34755C3.16001 5.33952 3.15861 5.33146 3.15741 5.32336C3.15621 5.31526 3.15521 5.30715 3.15441 5.29901C3.15361 5.29086 3.153 5.28271 3.1526 5.27454C3.1522 5.26636 3.15199 5.25818 3.15199 5.25C3.15199 5.24182 3.1522 5.23364 3.1526 5.22546C3.153 5.21729 3.15361 5.20914 3.15441 5.20099C3.15521 5.19285 3.15621 5.18473 3.15741 5.17663C3.15861 5.16853 3.16001 5.16048 3.1616 5.15245C3.16321 5.14443 3.165 5.13645 3.16698 5.12851C3.16897 5.12058 3.17116 5.11269 3.17353 5.10485C3.17591 5.09702 3.17848 5.08925 3.18123 5.08156C3.18398 5.07386 3.18693 5.06622 3.19005 5.05866C3.1932 5.0511 3.19651 5.04362 3.2 5.03623C3.20351 5.02883 3.20719 5.02152 3.21103 5.0143C3.2149 5.00708 3.21893 4.99997 3.22314 4.99295C3.22734 4.98593 3.23171 4.97903 3.23626 4.97222C3.24081 4.96541 3.24552 4.95872 3.25039 4.95215C3.25527 4.94557 3.26031 4.93913 3.26549 4.9328C3.27069 4.92648 3.27603 4.92028 3.28152 4.91422C3.28703 4.90816 3.29266 4.90224 3.29844 4.89645C3.30423 4.89066 3.31016 4.88502 3.31622 4.87952C3.32229 4.87403 3.32848 4.86868 3.3348 4.86349C3.34113 4.8583 3.34758 4.85327 3.35415 4.8484C3.36073 4.84352 3.36742 4.83881 3.37421 4.83427C3.38102 4.82972 3.38794 4.82535 3.39494 4.82114C3.40196 4.81693 3.40908 4.81289 3.4163 4.80904C3.42352 4.80518 3.43083 4.80151 3.43822 4.79801C3.44563 4.7945 3.45311 4.79119 3.46065 4.78806C3.46822 4.78493 3.47585 4.78198 3.48355 4.77922C3.49126 4.77647 3.49903 4.77391 3.50686 4.77154C3.51469 4.76916 3.52257 4.76698 3.53051 4.76499C3.53845 4.763 3.54643 4.76121 3.55445 4.75961C3.56248 4.75801 3.57054 4.75662 3.57864 4.75541C3.58673 4.7542 3.59486 4.75321 3.60299 4.75241C3.61113 4.7516 3.61929 4.751 3.62746 4.75061C3.63564 4.7502 3.64382 4.75 3.652 4.75ZM5.5155 4.75C5.52368 4.75 5.53186 4.7502 5.54003 4.75061C5.54821 4.751 5.55636 4.7516 5.56451 4.75241C5.57265 4.75321 5.58077 4.7542 5.58886 4.75541C5.59696 4.75662 5.60502 4.75801 5.61303 4.75961C5.62107 4.76121 5.62905 4.763 5.63699 4.76499C5.64493 4.76698 5.65281 4.76916 5.66064 4.77154C5.66846 4.77391 5.67623 4.77647 5.68394 4.77922C5.69166 4.78198 5.69928 4.78493 5.70683 4.78806C5.7144 4.79119 5.72188 4.7945 5.72927 4.79801C5.73668 4.80151 5.74398 4.80518 5.7512 4.80904C5.75842 4.81289 5.76553 4.81693 5.77255 4.82114C5.77957 4.82535 5.78648 4.82972 5.79328 4.83427C5.80009 4.83881 5.80678 4.84352 5.81334 4.8484C5.81992 4.85327 5.82636 4.8583 5.83269 4.86349C5.83902 4.86868 5.84522 4.87403 5.85128 4.87952C5.85735 4.88502 5.86327 4.89066 5.86905 4.89645C5.87484 4.90224 5.88048 4.90816 5.88598 4.91422C5.89147 4.92028 5.89682 4.92648 5.902 4.93281C5.9072 4.93913 5.91223 4.94557 5.9171 4.95215C5.92198 4.95872 5.92669 4.96541 5.93123 4.97222C5.93578 4.97903 5.94016 4.98593 5.94436 4.99295C5.94858 4.99997 5.95261 5.00708 5.95645 5.0143C5.96032 5.02152 5.964 5.02883 5.96749 5.03623C5.971 5.04362 5.97431 5.0511 5.97743 5.05866C5.98057 5.06622 5.98351 5.07386 5.98627 5.08156C5.98903 5.08925 5.9916 5.09702 5.99396 5.10486C5.99634 5.11269 5.99852 5.12058 6.00051 5.12851C6.00251 5.13645 6.00429 5.14443 6.00588 5.15245C6.00749 5.16048 6.00889 5.16853 6.01009 5.17663C6.01128 5.18473 6.01229 5.19285 6.01309 5.20099C6.0139 5.20914 6.0145 5.21729 6.01489 5.22546C6.01529 5.23364 6.01549 5.24182 6.01549 5.25C6.01549 5.25818 6.01529 5.26636 6.01489 5.27454C6.0145 5.28271 6.0139 5.29086 6.01309 5.29901C6.01229 5.30715 6.01128 5.31526 6.01009 5.32336C6.00889 5.33146 6.00749 5.33952 6.00589 5.34755C6.0043 5.35557 6.00251 5.36356 6.00051 5.37149C5.99852 5.37942 5.99634 5.38731 5.99396 5.39514C5.9916 5.40298 5.98903 5.41075 5.98627 5.41845C5.98351 5.42615 5.98057 5.43379 5.97744 5.44134C5.97431 5.4489 5.971 5.45638 5.96749 5.46377C5.964 5.47117 5.96032 5.47848 5.95645 5.4857C5.95261 5.49292 5.94858 5.50003 5.94436 5.50705C5.94016 5.51407 5.93578 5.52097 5.93123 5.52778C5.92669 5.53459 5.92198 5.54128 5.9171 5.54786C5.91223 5.55443 5.9072 5.56088 5.902 5.5672C5.89682 5.57352 5.89147 5.57972 5.88598 5.58578C5.88048 5.59184 5.87484 5.59777 5.86905 5.60356C5.86327 5.60934 5.85735 5.61498 5.85128 5.62048C5.84522 5.62597 5.83902 5.63132 5.83269 5.63651C5.82636 5.6417 5.81992 5.64673 5.81334 5.6516C5.80678 5.65648 5.80009 5.66119 5.79328 5.66573C5.78648 5.67028 5.77957 5.67465 5.77255 5.67886C5.76553 5.68307 5.75842 5.68711 5.7512 5.69097C5.74398 5.69482 5.73668 5.69849 5.72927 5.70199C5.72188 5.7055 5.7144 5.70881 5.70683 5.71194C5.69928 5.71507 5.69166 5.71801 5.68394 5.72077C5.67623 5.72352 5.66846 5.72609 5.66064 5.72847C5.65281 5.73084 5.64493 5.73302 5.63699 5.73502C5.62905 5.737 5.62107 5.73879 5.61303 5.7404C5.60502 5.74199 5.59696 5.74338 5.58886 5.74459C5.58077 5.7458 5.57265 5.74679 5.56451 5.74759C5.55636 5.7484 5.54821 5.749 5.54003 5.7494C5.53186 5.74981 5.52368 5.75 5.5155 5.75C5.50732 5.75 5.49914 5.74981 5.49096 5.7494C5.48279 5.749 5.47464 5.7484 5.46649 5.74759C5.45835 5.74679 5.45023 5.7458 5.44213 5.74459C5.43404 5.74338 5.42598 5.74199 5.41795 5.7404C5.40993 5.73879 5.40194 5.737 5.39401 5.73502C5.38607 5.73302 5.37818 5.73084 5.37035 5.72847C5.36252 5.72609 5.35476 5.72352 5.34705 5.72077C5.33934 5.71801 5.33171 5.71507 5.32416 5.71194C5.3166 5.70881 5.30912 5.7055 5.30171 5.70199C5.29432 5.69849 5.28702 5.69482 5.2798 5.69097C5.27258 5.68711 5.26547 5.68307 5.25845 5.67886C5.25143 5.67465 5.24451 5.67028 5.23771 5.66573C5.23091 5.66119 5.22422 5.65648 5.21764 5.6516C5.21108 5.64673 5.20462 5.6417 5.1983 5.63651C5.19198 5.63132 5.18578 5.62597 5.17971 5.62048C5.17365 5.61498 5.16773 5.60934 5.16194 5.60356C5.15616 5.59777 5.15052 5.59184 5.14502 5.58578C5.13953 5.57972 5.13418 5.57352 5.12899 5.56719C5.1238 5.56088 5.11876 5.55442 5.11389 5.54784C5.10902 5.54127 5.10431 5.53459 5.09977 5.52778C5.09522 5.52097 5.09085 5.51407 5.08663 5.50705C5.08243 5.50003 5.0784 5.49292 5.07453 5.4857C5.07068 5.47848 5.067 5.47117 5.0635 5.46377C5.06 5.45638 5.0567 5.4489 5.05356 5.44134C5.05043 5.43379 5.04749 5.42615 5.04472 5.41845C5.04197 5.41075 5.0394 5.40298 5.03702 5.39514C5.03466 5.38731 5.03248 5.37942 5.03048 5.37149C5.02849 5.36356 5.0267 5.35557 5.0251 5.34755C5.02351 5.33952 5.02211 5.33146 5.02091 5.32336C5.01971 5.31526 5.01871 5.30715 5.01791 5.29901C5.01711 5.29086 5.0165 5.28271 5.01609 5.27454C5.01569 5.26636 5.0155 5.25818 5.0155 5.25C5.0155 5.24182 5.01569 5.23364 5.01609 5.22546C5.0165 5.21729 5.01711 5.20914 5.01791 5.20099C5.01871 5.19285 5.01971 5.18473 5.02091 5.17663C5.02211 5.16853 5.02351 5.16048 5.0251 5.15245C5.0267 5.14443 5.02849 5.13645 5.03048 5.12851C5.03248 5.12058 5.03466 5.11269 5.03702 5.10485C5.0394 5.09702 5.04197 5.08925 5.04472 5.08156C5.04749 5.07386 5.05043 5.06622 5.05356 5.05866C5.0567 5.0511 5.06 5.04362 5.0635 5.03623C5.067 5.02883 5.07068 5.02152 5.07453 5.0143C5.0784 5.00708 5.08243 4.99997 5.08663 4.99295C5.09085 4.98593 5.09522 4.97903 5.09977 4.97222C5.10431 4.96541 5.10901 4.95872 5.11389 4.95215C5.11876 4.94557 5.1238 4.93913 5.12899 4.9328C5.13418 4.92648 5.13953 4.92028 5.14502 4.91422C5.15052 4.90816 5.15616 4.90224 5.16194 4.89645C5.16773 4.89066 5.17365 4.88502 5.17971 4.87952C5.18578 4.87403 5.19198 4.86868 5.1983 4.86349C5.20462 4.8583 5.21108 4.85327 5.21764 4.8484C5.22422 4.84352 5.23091 4.83881 5.23771 4.83427C5.24451 4.82972 5.25143 4.82535 5.25845 4.82114C5.26547 4.81693 5.27258 4.81289 5.2798 4.80904C5.28702 4.80518 5.29432 4.80151 5.30171 4.79801C5.30912 4.7945 5.3166 4.79119 5.32416 4.78806C5.33171 4.78493 5.33934 4.78198 5.34705 4.77922C5.35476 4.77647 5.36252 4.77391 5.37035 4.77154C5.37818 4.76916 5.38607 4.76698 5.394 4.76499C5.40194 4.763 5.40993 4.76121 5.41795 4.75961C5.42598 4.75801 5.43404 4.75662 5.44213 4.75541C5.45023 4.7542 5.45835 4.75321 5.46649 4.75241C5.47464 4.7516 5.48279 4.751 5.49096 4.75061C5.49914 4.7502 5.50732 4.75 5.5155 4.75ZM7.37875 4.75C7.38693 4.75 7.3951 4.7502 7.40328 4.75061C7.41146 4.751 7.41962 4.7516 7.42775 4.75241C7.4359 4.75321 7.44402 4.7542 7.45212 4.75541C7.46021 4.75662 7.46828 4.75801 7.47629 4.75961C7.48432 4.76121 7.4923 4.763 7.50023 4.76499C7.50818 4.76698 7.51607 4.76916 7.52389 4.77154C7.53172 4.77391 7.53949 4.77647 7.54719 4.77922C7.5549 4.78198 7.56253 4.78493 7.57009 4.78806C7.57765 4.79119 7.58512 4.7945 7.59252 4.79801C7.59993 4.80151 7.60723 4.80518 7.61444 4.80904C7.62166 4.81289 7.62879 4.81693 7.6358 4.82114C7.64282 4.82535 7.64973 4.82972 7.65653 4.83427C7.66334 4.83881 7.67003 4.84352 7.67659 4.8484C7.68318 4.85327 7.68962 4.8583 7.69594 4.86349C7.70226 4.86868 7.70846 4.87403 7.71452 4.87952C7.72059 4.88502 7.72651 4.89066 7.7323 4.89645C7.73809 4.90224 7.74373 4.90816 7.74922 4.91422C7.75472 4.92028 7.76006 4.92648 7.76525 4.93281C7.77044 4.93913 7.77547 4.94557 7.78035 4.95215C7.78522 4.95872 7.78993 4.96541 7.79448 4.97222C7.79903 4.97903 7.80341 4.98593 7.8076 4.99295C7.81182 4.99997 7.81585 5.00708 7.81971 5.0143C7.82357 5.02152 7.82725 5.02883 7.83074 5.03623C7.83424 5.04362 7.83756 5.0511 7.84069 5.05866C7.84383 5.06622 7.84677 5.07386 7.84952 5.08156C7.85228 5.08925 7.85484 5.09702 7.85721 5.10486C7.85959 5.11269 7.86177 5.12058 7.86376 5.12851C7.86575 5.13645 7.86755 5.14443 7.86914 5.15245C7.87073 5.16048 7.87214 5.16853 7.87334 5.17663C7.87454 5.18473 7.87554 5.19285 7.87634 5.20099C7.87714 5.20914 7.87774 5.21729 7.87814 5.22546C7.87855 5.23364 7.87875 5.24182 7.87875 5.25C7.87875 5.25818 7.87855 5.26636 7.87814 5.27454C7.87774 5.28271 7.87714 5.29086 7.87634 5.29901C7.87554 5.30715 7.87454 5.31526 7.87334 5.32336C7.87214 5.33146 7.87073 5.33952 7.86914 5.34755C7.86755 5.35557 7.86575 5.36356 7.86376 5.37149C7.86177 5.37942 7.85959 5.38731 7.85721 5.39514C7.85484 5.40298 7.85228 5.41075 7.84951 5.41845C7.84677 5.42615 7.84383 5.43379 7.84069 5.44134C7.83756 5.4489 7.83424 5.45638 7.83074 5.46377C7.82725 5.47117 7.82357 5.47848 7.81971 5.4857C7.81585 5.49292 7.81182 5.50003 7.8076 5.50705C7.80341 5.51407 7.79903 5.52097 7.79448 5.52778C7.78993 5.53459 7.78522 5.54128 7.78035 5.54786C7.77547 5.55443 7.77044 5.56088 7.76525 5.5672C7.76006 5.57352 7.75472 5.57972 7.74922 5.58578C7.74373 5.59184 7.73809 5.59777 7.7323 5.60356C7.72651 5.60934 7.72059 5.61498 7.71452 5.62048C7.70846 5.62597 7.70226 5.63132 7.69594 5.63651C7.68962 5.6417 7.68318 5.64673 7.67659 5.6516C7.67003 5.65648 7.66334 5.66119 7.65653 5.66573C7.64973 5.67028 7.64282 5.67465 7.6358 5.67886C7.62879 5.68307 7.62166 5.68711 7.61444 5.69097C7.60723 5.69482 7.59993 5.69849 7.59252 5.70199C7.58512 5.7055 7.57765 5.70881 7.57009 5.71194C7.56253 5.71507 7.5549 5.71801 7.54719 5.72077C7.53949 5.72352 7.53172 5.72609 7.52388 5.72847C7.51605 5.73084 7.50818 5.73302 7.50023 5.73502C7.4923 5.737 7.48432 5.73879 7.47629 5.7404C7.46828 5.74199 7.46021 5.74338 7.45212 5.74459C7.44402 5.7458 7.4359 5.74679 7.42775 5.74759C7.41962 5.7484 7.41146 5.749 7.40328 5.7494C7.3951 5.74981 7.38693 5.75 7.37875 5.75C7.37057 5.75 7.36239 5.74981 7.35421 5.7494C7.34604 5.749 7.33788 5.7484 7.32974 5.74759C7.3216 5.74679 7.31348 5.7458 7.30537 5.74459C7.29729 5.74338 7.28923 5.74199 7.2812 5.7404C7.27318 5.73879 7.2652 5.737 7.25726 5.73502C7.24932 5.73302 7.24144 5.73084 7.2336 5.72847C7.22577 5.72609 7.21801 5.72352 7.2103 5.72077C7.2026 5.71801 7.19497 5.71507 7.1874 5.71194C7.17984 5.70881 7.17237 5.7055 7.16497 5.70199C7.15758 5.69849 7.15026 5.69482 7.14305 5.69097C7.13583 5.68711 7.12871 5.68307 7.12169 5.67886C7.11468 5.67465 7.10776 5.67028 7.10096 5.66573C7.09417 5.66119 7.08748 5.65648 7.08089 5.6516C7.07433 5.64673 7.06788 5.6417 7.06155 5.63651C7.05523 5.63132 7.04904 5.62597 7.04297 5.62048C7.03691 5.61498 7.03098 5.60934 7.02519 5.60356C7.0194 5.59777 7.01376 5.59184 7.00827 5.58578C7.00278 5.57972 6.99744 5.57352 6.99224 5.56719C6.98706 5.56088 6.98202 5.55442 6.97714 5.54784C6.97227 5.54127 6.96756 5.53459 6.96301 5.52778C6.95846 5.52097 6.95409 5.51407 6.94989 5.50705C6.94568 5.50003 6.94165 5.49292 6.93778 5.4857C6.93394 5.47848 6.93026 5.47117 6.92675 5.46377C6.92326 5.45638 6.91994 5.4489 6.9168 5.44134C6.91368 5.43379 6.91073 5.42615 6.90797 5.41845C6.90523 5.41075 6.90266 5.40298 6.90028 5.39514C6.89791 5.38731 6.89572 5.37942 6.89373 5.37149C6.89174 5.36356 6.88994 5.35557 6.88835 5.34755C6.88676 5.33952 6.88536 5.33146 6.88416 5.32336C6.88296 5.31526 6.88195 5.30715 6.88116 5.29901C6.88036 5.29086 6.87975 5.28271 6.87935 5.27454C6.87895 5.26636 6.87874 5.25818 6.87874 5.25C6.87874 5.24182 6.87895 5.23364 6.87935 5.22546C6.87975 5.21729 6.88036 5.20914 6.88116 5.20099C6.88195 5.19285 6.88296 5.18473 6.88416 5.17663C6.88536 5.16853 6.88676 5.16048 6.88835 5.15245C6.88994 5.14443 6.89174 5.13645 6.89373 5.12851C6.89572 5.12058 6.89791 5.11269 6.90028 5.10485C6.90266 5.09702 6.90523 5.08925 6.90797 5.08156C6.91073 5.07386 6.91368 5.06622 6.9168 5.05866C6.91994 5.0511 6.92326 5.04362 6.92675 5.03623C6.93026 5.02883 6.93394 5.02152 6.93778 5.0143C6.94165 5.00708 6.94568 4.99997 6.94989 4.99295C6.95409 4.98593 6.95846 4.97903 6.96301 4.97222C6.96756 4.96541 6.97227 4.95872 6.97714 4.95215C6.98202 4.94557 6.98706 4.93913 6.99224 4.9328C6.99744 4.92648 7.00278 4.92028 7.00827 4.91422C7.01376 4.90816 7.0194 4.90224 7.02519 4.89645C7.03098 4.89066 7.03691 4.88502 7.04297 4.87952C7.04904 4.87403 7.05523 4.86868 7.06155 4.86349C7.06788 4.8583 7.07433 4.85327 7.08089 4.8484C7.08748 4.84352 7.09417 4.83881 7.10096 4.83427C7.10776 4.82972 7.11468 4.82535 7.12169 4.82114C7.12871 4.81693 7.13583 4.81289 7.14305 4.80904C7.15026 4.80518 7.15758 4.80151 7.16497 4.79801C7.17237 4.7945 7.17984 4.79119 7.1874 4.78806C7.19497 4.78493 7.2026 4.78198 7.2103 4.77922C7.21801 4.77647 7.22577 4.77391 7.2336 4.77154C7.24144 4.76916 7.24932 4.76698 7.25726 4.76499C7.2652 4.763 7.27318 4.76121 7.2812 4.75961C7.28923 4.75801 7.29729 4.75662 7.30537 4.75541C7.31348 4.7542 7.3216 4.75321 7.32974 4.75241C7.33788 4.7516 7.34604 4.751 7.35421 4.75061C7.36239 4.7502 7.37057 4.75 7.37875 4.75Z"
                      fill="#A6A6A6"
                    ></path>
                  </svg>
                  {{ item.useTimes }}
                </div>
                <div>@{{ item.CreateMan }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script setup>
import {
  reactive,
  ref,
  onMounted,
  onUnmounted,
  watch,
  getCurrentInstance,
} from "vue";
import {
  UserOutlined,
  CommentOutlined,
  RightOutlined,
} from "@ant-design/icons-vue";
import { debounce } from "lodash";
import MarketCards from "./marketcards.vue";
import QS from "qs";
import { message } from "ant-design-vue";

const { proxy } = getCurrentInstance();

let searchVal = ref(""); // 搜索框的值
let activeKey = ref(); // 选中的标签
let searchFlag = ref(false); // 搜索框是否显示
let searchStr = ref(""); // 搜索字符串
const onSearch = () => {
  console.log("搜索框的值：", searchVal.value);
  if (searchVal.value) {
    searchFlag.value = true; // 显示搜索结果
    searchStr.value = searchVal.value; // 设置搜索字符串
  } else {
    searchFlag.value = false; // 显示搜索结果
    searchStr.value = ""; // 设置搜索字符串
  }
};

const searchChange = debounce(() => {
  console.log("搜索框的值111：", searchVal.value);
  if (searchVal.value) {
    searchFlag.value = true; // 显示搜索结果
    searchStr.value = searchVal.value; // 设置搜索字符串
  } else {
    searchFlag.value = false; // 隐藏搜索结果
    searchStr.value = ""; // 清空搜索字符串
  }
}, 1000);

let tagName = ref(""); // 选中标签名称

const state = reactive({
  commonLists: [
    { name: "我常用的", id: 1, sectionId: "section1" },
    { name: "热门", id: 2, sectionId: "section2" },
    { name: "新上线", id: 3, sectionId: "section3" },
    { name: "IS", id: 4, sectionId: "section4" },
    { name: "HR", id: 5, sectionId: "section5" },
    { name: "IT", id: 6, sectionId: "section6" },
  ],
  marketLists: [
    // { name: "我常用的", id: 1, sectionId: "section1" },
    // { name: "热门", id: 2, sectionId: "section2" },
    // { name: "新上线", id: 3, sectionId: "section3" },
    // { name: "IS", id: 4, sectionId: "section4" },
    // { name: "HR", id: 5, sectionId: "section5" },
    // { name: "IT", id: 6, sectionId: "section6" },
  ],
  allData: {},
});

const changeTags = (id, name) => {
  activeKey.value = id;
  tagName.value = name;
  console.log("选中的标签ID：", id, "选中的标签名称：", name);
  searchFlag.value = true;
};

const items = ref([]); // 数据列表
const loadMore = ref("pending"); // 加载状态：pending/loading/nomore
const page = ref(1); // 当前页码
const pageSize = 15; // 每页数据量
const totalItems = 50; // 总数据量（模拟）
const loadMoreRef = ref(null); // 加载更多元素的引用

// 模拟异步加载数据
const fetchData = (pageNum, size) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      const newData = Array.from({ length: size }, (_, i) => ({
        id: pageNum * size + i + 1,
        title: `数字员工人才 ${pageNum * size + i + 1}`,
      }));
      resolve(newData);
    }, 1000); // 模拟网络延迟
  });
};
const loadMoreData = async () => {
  // eslint-disable-next-line curly
  if (loadMore.value === "nomore") return;

  try {
    loadMore.value = "loading";
    const newData = await fetchData(page.value, pageSize);
    debugger
    if (newData.length > 0) {
      items.value = [...items.value, ...newData];
      page.value++;
    }

    if (items.value.length >= totalItems) {
      loadMore.value = "nomore";
    } else {
      loadMore.value = "pending";
    }
  } catch (error) {
    console.error("加载失败:", error);
    loadMore.value = "pending";
  }
};

const handleScroll = debounce(() => {
  const scrollBottom =
    document.documentElement.scrollHeight -
    (document.documentElement.scrollTop + window.innerHeight);

  console.log("scrollBottom: ", scrollBottom);

  if (scrollBottom < 50 && loadMore.value === "pending") {
    loadMoreData();
  }
}, 2000);
// 初始化数据
const init = async () => {
  await loadMoreData();
};

const scrollToSection = (item) => {
  const { sectionId, id, name } = item;
  if (activeKey.value === id) {
    activeKey.value = 0;
    tagName.value = "";
    if(!searchVal.value && !tagName.value) {
      searchFlag.value = false;
    }
    return; // 如果当前选中的标签已经是该标签，则不执行滚动
  }
  activeKey.value = id;
  tagName.value = name;
  if (searchFlag.value) {
    return; // 如果是搜索结果，不滚动到指定区域
  }
  const element = document.getElementById(sectionId);
  if (element) {
    element.scrollIntoView({
      behavior: "smooth", // 平滑滚动
      block: "start", // 滚动到元素顶部
    });
  }
};

// 请求接口getTalentPlazaList
const getTalentPlazaListApi = () => {
  const params = {
    uid: proxy.$store.state.userID,
    email: "",
    currentPage: 0,
    pageSize: 10,
    searchKey: ["", ""],
  };
  proxy.$api.dashboardAPI
    .getTalentPlazaList(QS.stringify(params))
    .then((res) => {
      console.log("getTalentPlazaListApi", res.data.Data);
      if (res.data.Success) {
        state.allData = res.data.Data;
        state.marketLists = state.allData.dataTable.label?.map(
          (item, index) => ({
            name: item,
            id: index + 1,
            sectionId: `section${index + 1}`,
          })
        );
      }
    });
};

getTalentPlazaListApi();

// 执行日志接口 addDigitalEmpLogs
const addDigitalEmpLogsApi = (params) => {
  proxy.$api.dashboardAPI
    .addDigitalEmpLogs(QS.stringify(params))
    .then((res) => {
      if (res.data.Success) {
        console.log("执行日志添加成功");
      } else {
        console.log("执行日志添加失败");

      }
    });
};

const handleClick = (item) => {
  console.log("点击了卡片：", item);
  if (item.otherPlatform) {
    // 执行日志接口
    addDigitalEmpLogsApi({
      PubID: item.id,
      UserID: proxy.$store.state.userID,
      Type: "1",
    });
    window.open(item.otherPlatform, "_blank");
  } else {
    message.warn("暂无开放该数字员工的使用入口");
  }
};
onMounted(() => {
  //init();
});

// 清理 Intersection Observer
// onUnmounted(() => {
//   if (observer) {
//     observer.disconnect();
//   }
// });
</script>

<style lang="scss" scoped>
.page-container {
  padding: 20px;
  //   background: linear-gradient(to bottom, #c1ddec, #d6e9f5, #ffffff);
  height: 100%;
  border-radius: 0.8rem;

  position: relative;
}

.page-header {
  position: sticky;
  top: 0px;
  // z-index: 999;

  background-color: #f4f6f8;
  .header-top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 0px;
    // background-color: #f0f0f0;
    border-radius: 5px;
  }
}

.top-title {
  font-size: 24px;
  font-weight: 600;
  cursor: pointer;
}

.header-bottom {
  display: flex;
  justify-content: flex-start;
  //   align-items: center;
  flex-wrap: wrap;
  .bottom-item {
    margin-right: 10px;
    padding: 5px 12px;
    background-color: #fff;
    border-radius: 0.5rem;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    margin-bottom: 10px;

    cursor: pointer;
  }
  .bottom-item-active {
    // background-color: #007bff;
    color: #1d75fa;
  }
}

.page-content {
  margin-top: 10px;
  .content-title {
    font-size: 20px;
    font-weight: 600;
    cursor: pointer;
    &:hover {
      color: #1d75fa;
    }
  }
  .content-cards {
    padding: 10px 0px;

    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-gap: 20px;
    margin-top: 10px;
    cursor: pointer;
    .cards-item {
      display: flex;
      padding: 10px;
      background-color: #fff;
      border-radius: 0.5rem;
      box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);

      .item-left {
        margin-right: 10px;
        width: 56px;
        height: 56px;
        border-radius: 50%;
        overflow: hidden;
        background-color: transparent;
        img {
          width: 56px;
          height: 56px;
          border-radius: 50%;
          object-fit: cover;
          cursor: pointer;
        }
      }
      .item-right {
        flex: 1;
        .__title {
          font-size: 16px;
          font-weight: 600;
          color: #1e1f24;
        }
        .__content {
          font-size: 14px;
          color: #50525c;
          //   超过两行省略
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }
        .__bottom {
          display: flex;
          //   justify-content: space-between;
          align-items: center;
          margin-top: 10px;
          color: #848691;
          font-size: 12px;
          text-align: center;
          line-height: normal;

          div {
            margin-right: 10px;
            vertical-align: middle;
          }
        }
      }
    }
  }
}

// hover卡片时给图片增加放大效果
.cards-item:hover img {
  transform: scale(1.3);
  transition: transform 0.5s ease;
}

.load-more {
  width: 100%;
  text-align: center;
  color: #b7b9c1;
}
</style>
